$(function () {
  var color_Swiper = new Swiper ('.item-scroll-box', {
    slidesPerView: 15,
    freeMode: true,
    scrollbar: '.swiper-scrollbar',
    breakpoints: {
      1400: {
        slidesPerView: 13,
      },
      1200: {
        slidesPerView: 10,
      },
      999: {
        slidesPerView: 8,
      },
      740: {
        slidesPerView: 6,
      },
      540: {
        slidesPerView: 6,
      },
      320: {
        slidesPerView: 4,
      }
    }
  });
  $('#color-items .item').on('mouseenter', function() {
    var $this = $(this);
    var $img = $this.find('.color_image');
    var $poa = $this.find('.poa');
    var $list = $poa.find('.list');

    if ($list.length <= 0) {
      $poa.remove();
      $this.addClass("no-poa");
    }

    $poa.show();
    $this.addClass("active");
    $('#color-items .item').not($this).find('.color_image').css({ width: '70px', height: '70px' });
    $img.css({ width: '80px', height: '80px' });

    var $prevItem = $this.prev('.item');
    var $nextItem = $this.next('.item');
        
    if ($prevItem.length) $prevItem.find('.color_image').css({ width: '75px', height: '75px' });
    if ($nextItem.length) $nextItem.find('.color_image').css({ width: '75px', height: '75px' });

    if ($this.is(':first-child')) $poa.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
    else if ($this.is(':last-child')) $poa.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
    else $poa.css({ left: '50%', transform: 'translateX(-50%)' });
  })
  $('#color-items .item').on('mouseleave', function() {
    var $this = $(this);
    var $img = $this.find('.color_image');
    var $poa = $this.find('.poa');

    $poa.hide();
    $this.removeClass("active");
    $img.css({ width: '70px', height: '70px' });

    var $prevItem = $this.prev('.item');
    var $nextItem = $this.next('.item');
        
    if ($prevItem.length) $prevItem.find('.color_image').css({ width: '70px', height: '70px' });
    if ($nextItem.length) $nextItem.find('.color_image').css({ width: '70px', height: '70px' });
  })
})